/* eslint-disable import/no-duplicates */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-new */
/* eslint-disable dot-notation */
import '../style/animation.css'
import 'antd/dist/antd.css'
import { ResetCSS } from '@pancakeswap/uikit'
import Script from 'next/script'
import dynamic from 'next/dynamic'
import BigNumber from 'bignumber.js'
import GlobalCheckClaimStatus from 'components/GlobalCheckClaimStatus'
import FixedSubgraphHealthIndicator from 'components/SubgraphHealthIndicator'
import { ToastListener } from 'contexts/ToastsContext'
import useEagerConnect from 'hooks/useEagerConnect'
import { useAccountEventListener } from 'hooks/useAccountEventListener'
import useSentryUser from 'hooks/useSentryUser'
import useUserAgent from 'hooks/useUserAgent'
import type { AppProps } from 'next/app'
import Head from 'next/head'
import { Fragment, useEffect } from 'react'
import { PersistGate } from 'redux-persist/integration/react'
import { useStore, persistor } from 'state'
import { usePollBlockNumber } from 'state/block/hooks'
import { NextPage } from 'next'
import PublicLayout from 'layouts/PublicLayout'
import useGetBalance from 'hooks/useGetBalance'
import useCheckAuthorization from 'state/auth/hooks/useCheckAuthorization'
import { TokenUpdater } from 'state/info/updaters'
import { useSelector } from 'react-redux'
import { useGetProfileUser } from 'state/user/hooks/useGetProfileUser'
import { useLoadCart } from 'hooks/useCart'
import { useRouter } from 'next/router'
import { useWalletModal } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import useAuth from 'hooks/useAuth'
import { setGetProfileUser } from 'hooks/setGetProfileUser'
import { PublicRouter } from 'config/constants'
import useGetCurrencyConverter from 'hooks/useGetCurrencyConverter'
import { useRateCurrency } from 'hooks/useRateCurrency'
import useGetNotification from 'state/notification/hooks/useGetNotification'
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging'
import { initializeApp } from 'firebase/app'
import { useWeb3React } from '@web3-react/core'
import { ToastContainer } from 'react-toastify'
import ModalMaketplace from 'components/ModalMaketplace'
import { Blocklist, Updaters } from '..'
import ErrorBoundary from '../components/ErrorBoundary'
import Providers from '../Providers'
import GlobalStyle from '../style/Global'
import firebaseConfig from './firebase.config.json'
import { useLocalStorage } from '../hooks/useLocalStorage'
import { useCreateNotiToken } from '../hooks/useCreateNotiToken'

const EasterEgg = dynamic(() => import('components/EasterEgg'), { ssr: false })

// This config is required for number formatting
BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

function GlobalHooks() {
  usePollBlockNumber()
  useEagerConnect()
  useUserAgent()
  useAccountEventListener()
  useSentryUser()
  return null
}

function MyApp(props: AppProps) {
  const { pageProps } = props
  const store = useStore(pageProps.initialReduxState)

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=5, minimum-scale=1, viewport-fit=cover"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="robots" content="noodp,noydir" />

        {/* <!-- Link --> */}
        <link rel="apple-touch-icon" type="image/x-icon" href="%PUBLIC_URL%/favicon.ico" />
        <link rel="shortcut icon" type="image/png" href="%PUBLIC_URL%/favicon.ico" />

        {/* <!-- Og --> */}
        <meta property="og:title" content="SOEI MARKET - A Next-Generation NFT Marketplace" />
        <meta
          property="og:description"
          content="Building a web3 platform, where every user has the right to self-determination with their own assets in an open and transparent manner."
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="SOEI MARKET - A Next-Generation NFT Marketplace" />
        <meta property="og:image:type" content="image/jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="SOEI" />
        <meta property="og:image" content="/graph.png?v=2" />
        <meta property="og:url" content="https://soei.social" />

        {/* <!-- Twitter --> */}
        <meta name="twitter:title" content="SOEI MARKET - A Next-Generation NFT Marketplace" />
        <meta
          name="twitter:description"
          content="Building a web3 platform, where every user has the right to self-determination with their own assets in an open and transparent manner."
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@SOEI" />
        <meta name="twitter:image" content="/graph.png?v=2" />
        <meta name="twitter:creator" content="@SOEI" />

        {/* <!-- Title --> */}
        <title>SOEI MARKET - A Next-Generation NFT Marketplace</title>
        <meta name="keywords" content="SOEI,NFT,Marketplace" />
        <meta
          name="description"
          content="Building a web3 platform, where every user has the right to self-determination with their own assets in an open and transparent manner."
        />
      </Head>
      <Providers store={store}>
        <Blocklist>
          <GlobalHooks />
          <Updaters />
          <ResetCSS />
          <GlobalStyle />
          <GlobalCheckClaimStatus excludeLocations={[]} />
          <PersistGate loading={null} persistor={persistor}>
            <App {...props} />
          </PersistGate>
        </Blocklist>
      </Providers>
      <Script async src="https://www.googletagmanager.com/gtag/js?id=G-RBHVR77MH2" />
      <Script
        strategy="afterInteractive"
        id="google-tag"
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
        
          gtag('config', 'G-RBHVR77MH2');        
          `,
        }}
      />
    </>
  )
}

type NextPageWithLayout = NextPage & {
  Layout?: React.FC
  fullLayout?: boolean
}

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout
}

const ProductionErrorBoundary = process.env.NODE_ENV === 'production' ? ErrorBoundary : Fragment

const App = ({ Component, pageProps, ...props }: AppPropsWithLayout) => {
  useCheckAuthorization()
  useGetCurrencyConverter()
  useLoadCart()
  useRateCurrency()
  useGetNotification()

  const [getProfileUser] = useGetProfileUser()

  const { filterBlur } = useSelector((state: any) => state.global)

  useEffect(() => {
    getProfileUser()
  }, [getProfileUser])

  // Use the layout defined at the page level, if available
  const Layout = Fragment

  const googleTranslateElementInit = () => {
    new window['google'].translate.TranslateElement(
      {
        pageLanguage: 'en',
        autoDisplay: false,
      },
      'google_translate_element',
    )
  }

  const [fcmToken, setFcmToken] = useLocalStorage('fcm_token', null)
  const { account } = useWeb3React()

  useEffect(() => {
    const addScript = document.createElement('script')
    addScript.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit')
    document.body.appendChild(addScript)
    window['googleTranslateElementInit'] = googleTranslateElementInit

    const isSuppportFirebase = async () => {
      const hasFirebaseMessagingSupport = await isSupported()
      if (hasFirebaseMessagingSupport) {
        const fapp = initializeApp(firebaseConfig)
        const messaging = getMessaging(fapp)

        if (!fcmToken) {
          getToken(messaging, {
            vapidKey: 'BBIhyn44uCylaHANTG3lUWgbX1nrnfaht0WMiTKrz2encnqWhmbeOYWBWrNiQPdsIUjVMf5uP1GfCQGFJPzQjp4',
          })
            .then((currentToken) => {
              if (currentToken) {
                setFcmToken(() => currentToken)
                useCreateNotiToken({
                  deviceType: 'web',
                  notificationToken: currentToken,
                  receiver: account,
                })
              } else {
                // Show permission request UI
                console.log('No registration token available. Request permission to generate one.')
              }
            })
            .catch((err) => {
              console.log('An error occurred while retrieving token. ', err)
            })
        }
      }
    }
    isSuppportFirebase()
  }, [])

  return (
    <ProductionErrorBoundary>
      <TokenUpdater />
      <div className={filterBlur ? 'filter-blur' : ''}>
        <Layout>
          <div id="google_translate_element" />
          {Component.fullLayout ? (
            <Component {...pageProps} />
          ) : (
            <PublicLayout>
              <Component {...pageProps} />
            </PublicLayout>
          )}
        </Layout>
      </div>
      <EasterEgg iterations={2} />
      <ToastListener />
      <FixedSubgraphHealthIndicator />
      <ModalMaketplace />
    </ProductionErrorBoundary>
  )
}

export default MyApp
